import {useDebugValue} from 'react';

import classNames from 'classnames';

import {useSearchFormContext} from '../../../hooks/useSearchFormContext';
import {useTrackingContext} from '../../../hooks/useTrackingContext';

import {showFormSummary, submitForm} from '../../../utils/form';

const formClassName = 'search-form';

function useComponent() {
    const {
        systemOptions,
        mediaSettings,
        abacusStore,
        edapOptions,
        latestSearchValues,
        formActions,
        formEvents,
        formOptions,
        formOptions: {
            layout,
            align
        },
        destinationActions,
        latestDestinationValues,
        latestDatesValues,
        latestGuestsValues
    } = useSearchFormContext();

    const trackingContext = useTrackingContext();

    const formLayoutClassName = `${formClassName}--${layout}`;
    const formAlignClassName = `${formClassName}--${align}`;

    const className = classNames(formClassName, formLayoutClassName, formAlignClassName);

    const showSummary = showFormSummary(mediaSettings, formOptions);

    function handleSubmit(event) {
        event.preventDefault();

        submitForm(trackingContext, systemOptions, abacusStore, edapOptions, latestSearchValues, formActions, formEvents, destinationActions, latestDestinationValues, latestDatesValues, latestGuestsValues);
    }

    const result = {
        className,
        showSummary,
        onSubmit: handleSubmit
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
